import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PRIVACY_FRAGMENT, TERMS_FRAGMENT } from './constants';
import { PolicySection } from './policy-section';
import { TermsSection } from './terms-section';

export interface PrivacyPolicyProps {
  accountName: string;
  supportContact: string;
}

export { PRIVACY_FRAGMENT, TERMS_FRAGMENT };

export function PrivacyPolicy({
  accountName,
  supportContact,
}: PrivacyPolicyProps) {
  return (
    <main className="prose prose-sm sm:prose lg:prose-lg mx-auto max-w-4xl px-4 py-8 text-gray-800">
      <header className="mb-8">
        <h1 className="text-3xl font-semibold">
          <FormattedMessage
            defaultMessage="{accountName} Privacy Policy & Terms of Service"
            description="Heading of the career site privacy policy and terms of service page"
            values={{ accountName }}
          />
        </h1>
        <p className="text-sm text-gray-500">
          <FormattedMessage
            defaultMessage="Effective Date: April 2026"
            description="Effective date label shown beneath the privacy page heading"
          />
        </p>
      </header>

      <PolicySection
        accountName={accountName}
        supportContact={supportContact}
      />

      <TermsSection accountName={accountName} supportContact={supportContact} />

      <footer className="mt-12 border-t pt-4 text-center text-sm">
        <a href={`#${PRIVACY_FRAGMENT}`} className="underline">
          <FormattedMessage
            defaultMessage="{accountName} Privacy Policy"
            description="Bottom-of-page link to the privacy policy section"
            values={{ accountName }}
          />
        </a>
        <span className="mx-2" aria-hidden="true">
          |
        </span>
        <a href={`#${TERMS_FRAGMENT}`} className="underline">
          <FormattedMessage
            defaultMessage="Terms of Service"
            description="Bottom-of-page link to the terms of service section"
          />
        </a>
      </footer>
    </main>
  );
}
